var _ = "_icon_1q1xv_1",
    t = "_base_16cjx_3",
    c = "_initial_16cjx_20",
    n = "_small_16cjx_25",
    e = "_medium_16cjx_30",
    i = "_large_16cjx_35",
    l = "_primary_16cjx_40 _base_16cjx_3",
    o = "_outline_16cjx_75 _base_16cjx_3",
    s = "_text_16cjx_120 _base_16cjx_3",
    a = "_buttonIcon_16cjx_163",
    x = "_filledOutline_16cjx_207 _outline_16cjx_75 _base_16cjx_3",
    j = {
  icon: _,
  base: t,
  initial: c,
  small: n,
  medium: e,
  large: i,
  primary: l,
  outline: o,
  text: s,
  buttonIcon: a,
  filledOutline: x
};
export { t as base, a as buttonIcon, j as default, x as filledOutline, _ as icon, c as initial, i as large, e as medium, o as outline, l as primary, n as small, s as text };